import { AlertTriangle } from "lucide-react";
import { ROTULO_DO_ALERTA, type AlertaDaAnamnese } from "@bookdental/schemas";
import { trpc } from "@/lib/trpc";
import { useFeature } from "@/lib/use-feature";
import { usePermissao } from "@/lib/use-permissao";
import { cn } from "@/lib/cn";

/** Selos dos alertas da anamnese ("Alergia", "Anticoagulante"...). Só o código — o detalhe fica na aba. */
export function SelosDeAlerta({ alertas, compacto }: { alertas: string[]; compacto?: boolean }) {
  if (!alertas.length) return null;
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {alertas.map((a) => (
        <span
          key={a}
          className={cn(
            "inline-flex items-center gap-1 rounded-full bg-amber-50 font-semibold text-amber-800 ring-1 ring-amber-200",
            compacto ? "px-2 py-0.5 text-[10px]" : "px-2.5 py-0.5 text-[11px]",
          )}
        >
          <AlertTriangle className={compacto ? "h-3 w-3" : "h-3.5 w-3.5"} />
          {ROTULO_DO_ALERTA[a as AlertaDaAnamnese] ?? a}
        </span>
      ))}
    </div>
  );
}

/** Os selos do paciente no topo da ficha — só pra quem pode ver dado de saúde. */
export function SelosDaFicha({ patientId }: { patientId: string }) {
  const ligado = useFeature("patient.anamnese");
  const podeVer = usePermissao("anamnese.view");
  const q = trpc.anamnese.alertasPorPacientes.useQuery({ patientIds: [patientId] }, { enabled: ligado && podeVer });
  return <SelosDeAlerta alertas={q.data?.[patientId] ?? []} compacto />;
}
